import React, { useCallback } from "react";

import { cn } from "utils/cn";

export interface TabItem {
  id: string;
  label: string;
  className?: string;
  isSuccess?: boolean;
  isDisabled?: boolean;
}

interface TabItemsProps {
  tabs: TabItem[];
  activeTab: string;
  wrapperClassName?: string;
  onTabClick: (tab: TabItem) => void;
  isShowTicked?: boolean;
}

export const TabItems: React.FC<TabItemsProps> = ({
  tabs,
  activeTab,
  wrapperClassName,
  onTabClick,
  isShowTicked = true,
}) => {
  const renderIcon = useCallback((tab: TabItem, isActive: boolean) => {
    const iconConfig = {
      src: tab.isSuccess
        ? "/svg/checkedCircle.svg"
        : tab.isDisabled
        ? "/svg/uncheckedDisabled.svg"
        : isActive
        ? "/svg/uncheckedCircleWhite.svg"
        : "/svg/uncheckedCircle.svg",
      alt: tab.isSuccess ? "Checked Icon" : tab.isDisabled ? "Disabled Icon" : "UnChecked Icon",
    };

    return <img src={iconConfig.src} alt={iconConfig.alt} className="mr-2" />;
  }, []);

  return (
    <div className={cn("relative flex h-[44px] w-full gap-2", wrapperClassName)}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            role="tab"
            aria-selected={isActive}
            aria-controls={`panel-${tab.id}`}
            id={`tab-${tab.id}`}
            tabIndex={isActive ? 0 : -1}
            key={tab.id}
            onClick={() => onTabClick(tab)}
            className={cn(
              "flex w-[210px] cursor-pointer items-center justify-center rounded-t py-6",
              {
                "bg-footer-background": !isActive,
                "is-active bg-white": isActive,
                "cursor-not-allowed text-disabled": tab.isDisabled,
              },
              tab.className
            )}
            disabled={tab.isDisabled}
          >
            {isShowTicked && renderIcon(tab, isActive)}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};
